import { useParams } from 'react-router-dom'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { moduleByKey } from '@/lib/screens'

// A10 Moliya — data-driven skelet. MyGram PULSIZ dizayn (fiat-to'lov yo'q), shuning uchun
// A10 fiat-ekranlari (to'lov/chargeback/refund/provayder/yechish) va daromad-hisobotlari
// HAQIQIY ma'lumot uchun to'lov-provayder + AML yoki daromad-ETL infrasini kutadi. Skelet
// navigatsiya qilinadi, "jonli" hisobiga kirmaydi (halol %). Bitta komponent :id ni o'qiydi.
const REVENUE_IDS = new Set([
  'A10.22', 'A10.23', 'A10.24', 'A10.25', 'A10.26', 'A10.27', 'A10.28', 'A10.29', 'A10.30', 'A10.31',
])

function SkeletonBox({ className = '' }: { className?: string }) {
  return (
    <div className={`animate-pulse rounded-lg border border-dashed border-border-default bg-surface-2 ${className}`} />
  )
}

export function FinancePlanned() {
  const t = useT()
  const { id = '' } = useParams()
  const screen = moduleByKey('A10')?.screens.find((s) => s.id === id)
  const title = screen ? `${id} · ${screen.title}` : id
  const blocker = REVENUE_IDS.has(id) ? t.skeleton.needsRevenue : t.skeleton.needsPayments
  const kpis = REVENUE_IDS.has(id) ? 4 : 3
  return (
    <>
      <PageHeader title={title} screenId={id} />
      <div className="min-h-0 flex-1 space-y-3 overflow-auto p-3">
        <div className="flex items-start gap-3 rounded-lg border border-border-default bg-surface-2 p-3">
          <span aria-hidden className="mt-0.5 shrink-0 font-mono text-accent">
            ▲
          </span>
          <div>
            <p className="text-sm font-medium text-primary">{t.skeleton.bannerTitle}</p>
            <p className="mt-0.5 text-sm text-secondary">
              {t.skeleton.needs}: <span className="text-primary">{blocker}</span>
            </p>
            <p className="mt-1 text-xs text-tertiary">{t.skeleton.adapterReady}</p>
          </div>
        </div>
        <div className="grid max-w-3xl grid-cols-2 gap-2 md:grid-cols-4">
          {Array.from({ length: kpis }, (_, i) => (
            <SkeletonBox key={i} className="h-16" />
          ))}
        </div>
        <SkeletonBox className="h-40 max-w-3xl" />
      </div>
    </>
  )
}
